import classNames from "classnames";
import * as React from "react";
import { dateUtility } from "../../EasyProjectsCommon/Dates/DateUtility";
import * as styles from "./DatePresenter.less";

type DatePresenterProps = {
    date: Date;
    /** if TRUE, converts date to user time */
    isUtc?: boolean;
    className?: string;
    disableDefaultTheme?: boolean;
};

export const DatePresenter: React.FC<DatePresenterProps> = ({
    date,
    isUtc,
    className,
    disableDefaultTheme,
    children,
}) => {
    return (
        <div className={classNames(className, !disableDefaultTheme && styles.text)}>
            <span title={dateUtility.formatAsFullWithTime(date, { isUtc })}>
                {dateUtility.getElapsedTimeRepresentation(date, { includeTime: true, isUtc })}
            </span>
            {children && <span>{children}</span>}
        </div>
    );
};
